import React from 'react'
import PrintBillReceipt from './PrintBillReceipt/PrintBillReceipt'
import ComponentPay from '../ComponentPay'

const StatusManageRegist_9 = ({ DataRegister }) => {
  return (
    <>
      <ComponentPay data={DataRegister} />
      <PrintBillReceipt DataRegister={DataRegister} />
    </>


  )
}

export default StatusManageRegist_9